import isEqual from 'lodash/isEqual'
import * as elastic from '../data-elastic'

// ----------------------------------------------
// If list constains something only set in store
// if not existing
// ----------------------------------------------
export function drugs( names ) {

  return async ( dispatch, getState, api ) => {

    // Don't touch drugs in state
    if ( !names || Array.isArray( names ) == false || names.length == 0 ) {
      return Promise.resolve()
    }

    const { xeon } = getState()
    const { drugs = {} } = xeon

    // ---------------------------------------------------------------------------
    // Find for-drug
    // Only query if differences in store and params in view-advice
    // e.g. http://localhost:5002/clinic/advice/de/for-drug-acetylsalicylsäure-simvastatin/
    // e.g. http://localhost:5002/clinic/advice/de/for-drug-acetylsalicylsäure-simvastatin-dilam/
    // ---------------------------------------------------------------------------
    if ( names && !isEqual( names, Object.keys( drugs ) ) ) {
      // Query by name
      const items = await dispatch( elastic.drugsByNames( names ) )
      // Update store
      return dispatch( { type: "xeon.drugs", data: items } )
    }

    return Promise.resolve()

  }
}